document.addEventListener("DOMContentLoaded", function() {
	var overlay = document.getElementById("cart-drawer-overlay")
	var drawer = document.getElementById("cart-drawer")
	var closeBtn = document.getElementById("cart-drawer-close")
	var cartIcon = document.querySelector("[data-cart-drawer-open]")
	var cartLink = document.querySelector("a.site-header-cart--button")

	function openDrawer() {
		var overlay = document.getElementById("cart-drawer-overlay")
		var drawer = document.getElementById("cart-drawer")
		if (overlay) {
			overlay.classList.add("active")
			overlay.setAttribute("aria-hidden", "false")
		}
		if (drawer) {
			drawer.classList.add("active")
			drawer.focus()
		}
		document.body.classList.add("cart-drawer-open")
	}

	function closeDrawer() {
		var overlay = document.getElementById("cart-drawer-overlay")
		var drawer = document.getElementById("cart-drawer")
		if (overlay) {
			overlay.classList.remove("active")
			overlay.setAttribute("aria-hidden", "true")
		}
		if (drawer) {
			drawer.classList.remove("active")
		}
		document.body.classList.remove("cart-drawer-open")
	}

	function fetchAndRenderCartDrawerSection() {
		var overlay = document.getElementById("cart-drawer-overlay")
		var drawer = document.getElementById("cart-drawer")
		if (overlay) overlay.classList.add("active")
		if (drawer) drawer.classList.add("active")
		if (overlay) overlay.setAttribute("aria-hidden", "false")
		if (drawer) drawer.focus()
		document.body.classList.add("cart-drawer-open")

		// Show loading state
		var contents = document.getElementById("cart-drawer-contents")
		if (contents) contents.innerHTML = '<div class="cart-drawer-loading">Loading...</div>'

		// Use Section Rendering API
		fetch(window.location.pathname + "?sections=cart-drawer")
			.then(function(res) {
				return res.json()
			})
			.then(function(data) {
				if (data["cart-drawer"]) {
					var temp = document.createElement("div")
					temp.innerHTML = data["cart-drawer"]
					var newOverlay = temp.querySelector("#cart-drawer-overlay")
					var newDrawer = temp.querySelector("#cart-drawer")
					if (newOverlay && overlay && overlay.parentNode) {
						overlay.parentNode.replaceChild(newOverlay, overlay)
					}
					if (newDrawer && drawer && drawer.parentNode) {
						drawer.parentNode.replaceChild(newDrawer, drawer)
					}
					// Re-attach listeners after DOM replacement
					attachCartDrawerListeners()
					// Attach quantity selectors after DOM replacement
					// Re-open the drawer after replacement
					openDrawer()
				}
			})
	}

	function attachCartDrawerListeners() {
		var newCartIcon = document.querySelector("[data-cart-drawer-open]")
		var newCloseBtn = document.getElementById("cart-drawer-close")
		var newOverlay = document.getElementById("cart-drawer-overlay")
		var newDrawer = document.getElementById("cart-drawer")
		var newCartLink = document.querySelector("a.site-header-cart--button")

		if (newCartIcon) {
			newCartIcon.addEventListener("click", openDrawer)
		}
		if (newCloseBtn) {
			newCloseBtn.addEventListener("click", closeDrawer)
		}
		if (newOverlay) {
			newOverlay.addEventListener("click", closeDrawer)
		}
		document.addEventListener("keydown", function(e) {
			if (newDrawer.classList.contains("active") && e.key === "Escape") {
				closeDrawer()
			}
		})

		if (newCartLink) {
			newCartLink.addEventListener("click", function(e) {
				e.preventDefault()
				e.stopPropagation()
				if (newDrawer.classList.contains("active")) {
					closeDrawer()
				} else {
					openDrawer()
				}
			})
		}

		// Attach quantity selectors after DOM replacement
		attachCartDrawerQuantitySelectors()
	}

	function attachCartDrawerQuantitySelectors() {
		document.querySelectorAll("#cart-drawer .quantity-selector__button").forEach(function(btn) {
			btn.addEventListener("click", function(e) {
				e.preventDefault()
				e.stopPropagation()
				const currentQuantity = btn
					.closest("quantity-selector")
					.querySelector(".quantity-selector__input").value
				const lineId = btn
					.closest("quantity-selector")
					.querySelector(".quantity-selector__input")
					.getAttribute("data-line-id")
				const newQuantity = btn.name === "plus" ? currentQuantity + 1 : currentQuantity - 1
				triggerQtyChange(lineId, newQuantity)
			})
		})
	}

	function triggerQtyChange(lineId, quantity) {
		fetch("/cart/change.js", {
			method: "POST",
			body: JSON.stringify({ id: lineId, quantity: quantity }),
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			}
		})
			.then(function(res) {
				return res.json()
			})
			.then(function(data) {
				window.dispatchEvent(new Event("cartcount:update"))
			})
			.catch(function(err) {
				console.error("Cart quantity update failed:", err)
			})
	}

	if (cartIcon) {
		cartIcon.addEventListener("click", openDrawer)
	}
	if (closeBtn) {
		closeBtn.addEventListener("click", closeDrawer)
	}
	if (overlay) {
		overlay.addEventListener("click", closeDrawer)
	}
	document.addEventListener("keydown", function(e) {
		if (drawer.classList.contains("active") && e.key === "Escape") {
			closeDrawer()
		}
	})

	if (cartLink) {
		cartLink.addEventListener("click", function(e) {
			e.preventDefault()
			e.stopPropagation()
			if (drawer.classList.contains("active")) {
				closeDrawer()
			} else {
				openDrawer()
			}
		})
	}

	attachCartDrawerQuantitySelectors()

	// Add to cart function and assign to every data-product-form
	function addToCart(event) {
		event.preventDefault()
		const form = event.currentTarget
		const formData = new FormData(form)

		fetch(window.Shopify.routes.root + "cart/add.js", {
			method: "POST",
			body: formData
		})
			.then(response => response.json())
			.then(data => {
				if ((data.status && data.status === 422) || (data && data.status === "bad_request")) {
					console.error("Add to cart error:", data.description || data.message)
					return
				}
				console.log("Added to cart:", data)
				window.dispatchEvent(new Event("cartcount:update"))
			})
			.catch(error => {
				console.error("Error adding to cart:", error)
			})
	}

	document.querySelectorAll("form[data-product-form]").forEach(productForm => {
		productForm.addEventListener("submit", addToCart)
	})

	// Listen for global cart update events and refresh the cart drawer
	window.addEventListener("cartcount:update", function() {
		fetchAndRenderCartDrawerSection()
	})

	// Helper to trigger section rendering for the cart-drawer section
	window.renderCartDrawerSection = function() {
		fetchAndRenderCartDrawerSection()
	}
})
